const bookingConfig = {
  booking: {
    displayDurationDays: true,
  },
}

export default bookingConfig
